var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartofAccounts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77 38.5C77 59.763 59.763 77 38.5 77C17.237 77 0 59.763 0 38.5C0 17.237 17.237 0 38.5 0C59.763 0 77 17.237 77 38.5Z",
    fill: "#FDC5C5",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1429 33.5833H42.0714V36.5H27.1429V33.5833ZM27.1429 40.875H44.7857V43.7917H27.1429V40.875Z",
    fill: "#CF2A2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2857 19H21.7143C20.9944 19 20.304 19.3073 19.795 19.8543C19.286 20.4013 19 21.1431 19 21.9167V51.0833C19 51.8569 19.286 52.5987 19.795 53.1457C20.304 53.6927 20.9944 54 21.7143 54H54.2857C55.0056 54 55.696 53.6927 56.205 53.1457C56.714 52.5987 57 51.8569 57 51.0833V21.9167C57 21.1431 56.714 20.4013 56.205 19.8543C55.696 19.3073 55.0056 19 54.2857 19ZM54.2857 21.9167V24.8333H21.7143V21.9167H54.2857ZM21.7143 51.0833V27.75H54.2857V51.0833H21.7143Z",
    fill: "#CF2A2A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartofAccounts);
export default __webpack_public_path__ + "static/media/ChartofAccounts.0d236525e3df7e91209530aa9fc9cc29.svg";
export { ForwardRef as ReactComponent };